const logo = require("../images/arsenalconvergelogo.png");

export { logo };
